import Resizer from 'react-image-file-resizer';
import { apiFetch, apiDelete, apiGet, parseJsonResponse } from './apiClient';

const ALLOWED_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
  'application/vnd.ms-excel.sheet.macroenabled.12',
]);

const IMAGE_TYPES = new Set(['image/jpeg', 'image/png']);

export const resizeFile = (file, extension) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(file, 1500, 1500, extension, 70, 0, resolve, 'blob');
  });

export const uploadFile = async (fileVar, onlyImages = false, auftragID) => {
  const { file } = fileVar;

  if (!ALLOWED_TYPES.has(file.type)) {
    console.log('Filetyp ' + file.type + ' nicht erlaubt');
    return;
  }
  if (onlyImages && !IMAGE_TYPES.has(file.type)) return;

  const formData = new FormData();
  const resized = IMAGE_TYPES.has(file.type)
    ? await resizeFile(file, file.type)
    : file;
  formData.append('files', resized, `${auftragID}-${file.name}`);

  try {
    const response = await apiFetch('/helper/acl/upload', {
      method: 'POST',
      multipart: true,
      body: formData,
    });
    if (!response.ok) return `Request failed with status ${response.status}`;
    return await parseJsonResponse(response);
  } catch (error) {
    return error;
  }
};

export const openS3File = async (filename) => {
  const response = await apiGet(`/helper/files/${filename}`);
  const data = await parseJsonResponse(response);
  window.open(data.signedUrl, '_blank');
};

export const deleteFile = (fileId) => apiDelete(`/helper/acl/upload/${fileId}`);

export const downloadRenderFile = async (type, file_type, auftragID, gutachtenIDorAnforderung) => {
  try {
    const path = `/helper/render-docx/${type}/${auftragID}/${gutachtenIDorAnforderung}?file_type=${file_type}`;
    const fileResponse = await apiGet(path);
    const blob = await fileResponse.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = gutachtenIDorAnforderung
      ? `${type}-${auftragID}-${gutachtenIDorAnforderung}`
      : `${type}-${auftragID}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};
